// --------------------------------------------------
// 🪗 Drawers
// --------------------------------------------------

const drawers = document.querySelectorAll(".drawer");

drawers.forEach(function (drawer) {
  const drawer_content = drawer.querySelector(".drawer_content");
  const drawer_title = drawer.querySelector(".drawer_title");

  drawer_title.addEventListener("click", function (event) {
    if (gsap.getProperty(drawer_content, "display") === "none") {
      drawer.classList.add("is_active");
      gsap.set(drawer_content, {
        height: 0,
        opacity: 1,
        display: "block",
      });
      gsap.to(drawer_content, {
        height: "auto",
        duration: 0.5,
        ease: "power2.inOut",
        onComplete: function () {
          history.replaceState(null, null, drawer_title.getAttribute("href"));
          ScrollTrigger.refresh();
        },
      });
    } else {
      drawer.classList.remove("is_active");
      gsap.to(drawer_content, {
        height: 0,
        opacity: 0,
        duration: 0.5,
        ease: "power2.inOut",
        onComplete: function () {
          gsap.set(drawer_content, {
            height: "auto",
            display: "none",
          });
          window.location.hash = "!";
          ScrollTrigger.refresh();
        },
      });
    }
    event.preventDefault();
  });
});

// --------------------------------------------------
// 📱 Column animations on mobile
// --------------------------------------------------

// ScrollTrigger.matchMedia({
//   "(max-width: 1000px)": function () {
//     let farLefts = document.querySelectorAll('.column.span_3:first-child');
//     farLefts.forEach(function (farLeft) {
//       gsap.fromTo(
//         farLeft,
//         {
//           x: -40,
//         },
//         {
//           x: 0,
//           scrollTrigger: {
//             trigger: farLeft,
//             scrub: 0.1,
//             start: "top bottom",
//             end: "top center",
//           },
//         }
//       );
//     });
//     let farRights = document.querySelectorAll(".column.span_3:last-child");
//     farRights.forEach(function (farRight) {
//       gsap.fromTo(
//         farRight,
//         {
//           x: 40,
//         },
//         {
//           x: 0,
//           scrollTrigger: {
//             trigger: farRight,
//             scrub: 0.1,
//             start: "top bottom",
//             end: "top center",
//           },
//         }
//       );
//     });
//     return function () {
//       gsap.set([farLefts, farRights], {
//         x: 0,
//       });
//     };
//   },
// });

// --------------------------------------------------
// ⏯ Custom controls for video and audio
// --------------------------------------------------

let mediaWraps = document.querySelectorAll(
  ".video_wrap:not(.gif_mode), .audio_wrap"
);

mediaWraps.forEach(function (mediaWrap) {
  let media = mediaWrap.querySelector("video, audio");
  let controls = mediaWrap.querySelector(".controls_wrap");
  let duration;
  let progress;

  // Handle seeking
  mediaWrap.addEventListener("click", function (event) {
    // Return if button is clicked or duration is not yet defined
    if (event.target.matches(".controls *") || !duration) return;

    // Seek to the clicked position
    if (
      mediaWrap.classList.contains("is_played") &&
      !event.target.matches(".video_inner, .video_inner *")
    ) {
      let percentagePosition = event.offsetX / controls.offsetWidth;
      media.currentTime = percentagePosition * duration;
    }

    // Play/pause
    else if (mediaWrap.classList.contains("is_playing")) {
      media.pause();
      mediaWrap.classList.remove("is_playing");
    } else {
      media.play();
      mediaWrap.classList.add("is_playing");
    }
  });

  // Time update function (called periodically while playing)
  media.addEventListener("timeupdate", function () {
    // Format time
    let minutes = Math.floor(media.currentTime / 60);
    minutes = ("0" + minutes).slice(-2);
    let seconds = Math.floor(media.currentTime % 60);
    seconds = ("0" + seconds).slice(-2);

    // Update progress time
    if (
      controls.querySelector(".progress span").innerHTML !==
      `${minutes}:${seconds}`
    ) {
      controls.querySelector(
        ".progress span"
      ).innerHTML = `${minutes}:${seconds}`;
    }

    // Add class to paused media
    if (media.paused) {
      mediaWrap.classList.remove("is_playing");
    } else {
      mediaWrap.classList.add("is_playing");
    }

    // Add class to muted media
    if (media.muted) {
      mediaWrap.classList.add("is_muted");
    } else {
      mediaWrap.classList.remove("is_muted");
    }
  });

  // Progress function (called every frame)
  function setProgress() {
    // If duration has been retrieved
    if (duration) {
      // Set progress variable to current time divided by duration
      progress = media.currentTime / duration;

      // Animate progress bar
      gsap.to(controls.querySelector(".progress"), {
        x: -100 + progress * 100 + "%",
        duration: 0.25,
      });
    }

    // Add class to played media
    if (progress > 0) {
      mediaWrap.classList.add("is_played");
    } else {
      mediaWrap.classList.remove("is_played");
    }

    // Handle progress time visiblity
    let progressPixels =
      controls.querySelector(".progress").offsetWidth * progress;
    if (progressPixels > 100 && controls.offsetWidth - progressPixels > 120) {
      gsap.to(controls.querySelector(".progress span"), {
        autoAlpha: 1,
      });
    } else {
      gsap.to(controls.querySelector(".progress span"), {
        autoAlpha: 0,
      });
    }

    // Call this function on the next frame
    requestAnimationFrame(function () {
      setProgress();
    });
  }

  setProgress();

  // Set duration after media has loaded
  media.addEventListener("loadedmetadata", function () {
    duration = media.duration;
    let minutes = Math.floor(duration / 60);
    minutes = ("0" + minutes).slice(-2);
    let seconds = Math.floor(duration % 60);
    seconds = ("0" + seconds).slice(-2);
    controls.querySelector(
      "button.duration span"
    ).innerHTML = `${minutes}:${seconds}`;
  });

  // Handle play/pause on play button
  let playButton = controls.querySelector("button.play");
  playButton.addEventListener("click", function () {
    if (media.paused) {
      media.play();
      mediaWrap.classList.add("is_playing");
    } else {
      media.pause();
      mediaWrap.classList.remove("is_playing");
    }
  });

  // Handle back button
  let backButton = controls.querySelector("button.back");
  backButton.addEventListener("click", function () {
    media.currentTime = 0;
  });

  // Handle mute button
  let muteButton = controls.querySelector("button.mute");
  muteButton.addEventListener("click", function () {
    if (media.muted) {
      media.muted = false;
      mediaWrap.classList.remove("is_muted");
    } else {
      media.muted = true;
      mediaWrap.classList.add("is_muted");
    }
  });

  // Handle fullscreen button
  let fullscreenButton = controls.querySelector("button.fullscreen");
  fullscreenButton.addEventListener("click", function () {
    // Exit fullscreen if there's a fullscreen element
    if (document.fullscreenElement || document.webkitFullscreenElement) {
      // Modern browsers
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
      // Safari
      else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
    // Request fullscreen if there's no fullscreen element
    else {
      // Modern browsers
      if (mediaWrap.requestFullscreen) {
        mediaWrap.requestFullscreen();
      }
      // Safari
      else if (mediaWrap.webkitRequestFullscreen) {
        mediaWrap.webkitRequestFullscreen();
      }
      // Mobile Safari
      else if (media.webkitEnterFullscreen) {
        media.webkitEnterFullscreen();
      }
    }
  });
});

// --------------------------------------------------
// ✨ Home Load Animation
// --------------------------------------------------

if (
  document.body.classList.contains("t_home") &&
  document.documentElement.classList.contains("load_animation")
) {

  let tl = gsap.timeline({
    delay: 0.5,
    paused: true,
    defaults: {
      duration: 1,
      ease: "power1.inOut",
    },
    onStart: function () {
      gsap.set("html, body", {
        height: "100%",
        overflow: "hidden",
      });
    },
    onComplete: function () {
      gsap.set("html, body", {
        height: "auto",
        overflow: "auto",
      });
    },
  });

  gsap.set(".article_link", {
    yPercent: 100,
    autoAlpha: 1,
  });

  tl.add(".splash:not(.dupe)", function () {
    window.scrollTo(0, 0);
  });

  tl.to(".splash:not(.dupe)", {
    autoAlpha: 0,
  });

  tl.to(".article_link", {
    yPercent: 0,
    stagger: {
      amount: 0.1,
      from: "start",
    },
  }, "<");

  tl.to(".splash.dupe", {
    autoAlpha: 0,
  });

  tl.to("header:not(.article_link_outer header)", {
    autoAlpha: 1,
  }, "-=.25");

  tl.to(".article_link_outer:first-child .article_link_title:not(.dupe)", {
    autoAlpha: 1,
  }, "<");

  tl.to(".article_menu", {
    autoAlpha: 1,
  }, "<");

  ScrollTrigger.matchMedia({
    "(max-width: 1000px)": function () {
      tl.progress(1, false);
    },
    "(min-width: 1001px)": function () {
      document.documentElement.classList.add("loading");
      window.addEventListener("load", function () {
        document.documentElement.classList.remove("loading");
        tl.play();
      });
    },
  });

} else if (document.body.classList.contains("t_home")) {
  gsap.set(".article_link_outer:first-child .article_link_title:not(.dupe)", {
    autoAlpha: 1,
  });
}

// --------------------------------------------------
// ✨ Home Scroll Animation
// --------------------------------------------------

let articleLinks = gsap.utils.toArray(".article_link_outer");

if (document.body.classList.contains("t_home")) {
  history.scrollRestoration = "manual";

  document.querySelector(".logo").addEventListener("click", function (e) {
    gsap.to(window, {
      scrollTo: {
        y: 0,
      },
      duration: 1,
      ease: "linear",
    });
    e.preventDefault();
  });

  articleLinks.forEach(function (articleLink) {
    let link = articleLink.querySelector(".article_link");
    let linkInner = articleLink.querySelector(".article_link_inner");
    let articleTitle = articleLink.querySelector(".article_link_title:not(.dupe)");
    let articleTitleDupe = articleLink.querySelector(".article_link_title.dupe");
    let articleHeader = articleLink.querySelector("header");
    let articleSplash = articleLink.closest('.article_link_outer').querySelector('.article_splash');

    link.addEventListener("click", function (e) {
      let offsetTop = articleLink.getBoundingClientRect()["top"];

      ScrollTrigger.matchMedia({
        "(max-width: 1000px)": function () {
          if (offsetTop > window.innerHeight * 0.5) {
            gsap.to(window, {
              scrollTo: {
                y: articleLink,
              },
              duration: 1,
              ease: "power1.inOut",
            });
            e.preventDefault();
          }
        },
        "(min-width: 1001px)": function () {
          if (offsetTop > window.innerHeight * 0.5) {
            gsap.to(window, {
              scrollTo: {
                y: articleLink,
                // offsetY: window.innerHeight * -0.5,
              },
              duration: Math.abs(offsetTop) / 1500,
              ease: "linear",
            });
            e.preventDefault();
          }
        },
      });
    });

    ScrollTrigger.matchMedia({
      "(max-width: 1000px)": function () {
        let articleTimeline = gsap.timeline({
          defaults: {
            ease: "power1.inOut",
            duration: 1,
          },
          scrollTrigger: {
            scrub: true,
            trigger: articleLink,
            start: "top bottom",
            end: "top top",
          },
        });
        articleTimeline.to(linkInner, {
          autoAlpha: .25
        });
        articleTimeline.to(articleTitleDupe, {
          autoAlpha: 1
        }, '<');
        articleTimeline.to(articleTitle, {
          autoAlpha: 0
        }, '<');
        return function() {
          gsap.set(linkInner, {
            autoAlpha: 1,
          });
        };
      },
      "(min-width: 1001px)": function () {

        gsap.set(articleTitle,{
          autoAlpha: 0,
        });
        
        let articleTimeline = gsap.timeline({
          defaults: {
            ease: "power1.inOut",
            duration: 1,
          },
          scrollTrigger: {
            scrub: .5,
            trigger: articleLink,
            start: "top top",
            end: "bottom top",
          },
        });
    
        articleTimeline.to(linkInner, {
          scale: link.dataset.scale,
        });
        articleTimeline.to(
          articleLink.querySelector("video"),
          {
            autoAlpha: 0.25,
          },
          "<"
        );
        articleTimeline.to(
          articleHeader,
          {
            autoAlpha: 1,
          },
          "<"
        );
        articleTimeline.to(
          articleTitleDupe,
          {
            autoAlpha: 1,
          },
          "<"
        );
        articleTimeline.to(
          articleTitle,
          {
            autoAlpha: 0,
            duration: 0.25,
          },
          "-=.25"
        );
        articleTimeline.to(link, {
          duration: 0.25,
        });
        articleTimeline.to(link, {
          yPercent: -100 * link.dataset.scale,
          duration: 2,
        });
        articleTimeline.to(
          articleTitleDupe,
          {
            autoAlpha: 0,
            duration: 1,
          },
          "<"
        );
        articleTimeline.to(
          articleTitleDupe,
          {
            yPercent: -50,
            duration: 2,
          },
          "<"
        );
        articleTimeline.to(
          articleHeader,
          {
            autoAlpha: 0,
          },
          "<"
        );
        if (articleLink.nextElementSibling) {
          articleTimeline.set(
            articleLink.nextElementSibling.querySelector(
              ".article_link_title:not(.dupe)"
            ),
            {
              autoAlpha: 1,
            },
            "<"
          );
        }
      },
    });

  });
}

// --------------------------------------------------
// ⬇️ Scroll Menu
// --------------------------------------------------

if (articleLinks.length) {
  articleLinks.forEach(function (articleLink) {
    let id = articleLink.getAttribute("id");
    let link = document.querySelector('.article_menu a[href="#' + id + '"]');
    if (link) {
      ScrollTrigger.create({
        trigger: articleLink,
        start: "top-=1 top",
        end: "bottom top",
        onEnter: () => {
          articleLink.classList.add("is_active");
          link.classList.add("is_active");
        },
        onEnterBack: () => {
          articleLink.classList.add("is_active");
          link.classList.add("is_active");
        },
        onLeave: () => {
          articleLink.classList.remove("is_active");
          link.classList.remove("is_active");
        },
        onLeaveBack: () => {
          articleLink.classList.remove("is_active");
          link.classList.remove("is_active");
        },
      });
      ScrollTrigger.create({
        trigger: articleLink,
        start: "top center",
        end: "bottom top",
        onEnter: () => {
          articleLink.classList.add("is_clickable");
        },
        onEnterBack: () => {
          articleLink.classList.add("is_clickable");
        },
        onLeave: () => {
          articleLink.classList.remove("is_clickable");
        },
        onLeaveBack: () => {
          articleLink.classList.remove("is_clickable");
        },
      });
      link.addEventListener("click", function (e) {
        let offsetTop = articleLink.getBoundingClientRect()["top"];
        ScrollTrigger.matchMedia({
          "(max-width: 1000px)": function () {
            gsap.to(window, {
              scrollTo: {
                y: articleLink,
              },
              duration: 1,
              ease: "power1.inOut",
            });
          },
          "(min-width: 1001px)": function () {
            gsap.to(window, {
              scrollTo: {
                y: articleLink,
                // offsetY: window.innerHeight * -0.5,
              },
              duration: Math.abs(offsetTop) / 1500,
              ease: "linear",
            });
          },
        });
        e.preventDefault();
      });
    }
  });
}

// --------------------------------------------------
// 🎨 Layout Colors
// --------------------------------------------------

let colorBlocks = gsap.utils.toArray(".block_color[data-background_color], .block_color[data-text_color]");

if(colorBlocks.length) {
  window.addEventListener("load", function () {

    function animateColor(backgroundColor, textColor) {
      if (backgroundColor) {
        gsap.to(document.body, {
          "--background_color": backgroundColor,
          ease: "linear",
          duration: 0.25,
        });
      }
      if (textColor) {
        gsap.to(document.body, {
          "--color": textColor,
          ease: "linear",
          duration: 0.25,
        });
      }
    }
    
    colorBlocks.forEach(function (colorBlock, i) {
      let backgroundColor = colorBlock.dataset.background_color;
      let textColor = colorBlock.dataset.text_color;
    
      let prevBackgroundColor;
      let prevTextColor;
    
      if(colorBlocks[i - 1]) {
        prevBackgroundColor = colorBlocks[i - 1].dataset.background_color;
        prevTextColor = colorBlocks[i - 1].dataset.text_color;
      }
      else {
        prevBackgroundColor = gsap.getProperty(document.body, "--background_color");
        prevTextColor = gsap.getProperty(document.body, "--color");
      }
    
      ScrollTrigger.create({
        trigger: colorBlock,
        start: "top-=10 center",
        end: "top+=10 center",
        onEnter: () => {
          animateColor(backgroundColor, textColor);
        },
        onEnterBack: () => {
          animateColor(prevBackgroundColor, prevTextColor);
        },
      });
    });
  });
}

// --------------------------------------------------
// 🕑 Progress
// --------------------------------------------------

if (document.body.classList.contains("t_article")) {

  function updateScrollProgress() {
    const scrollHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const scrollPosition = window.pageYOffset;
    const scrollPercentage = (scrollPosition / scrollHeight) * 100;
    gsap.to(document.documentElement, {
      "--progress": scrollPercentage,
    });
  }
  updateScrollProgress();
  window.addEventListener("scroll", updateScrollProgress);
  window.addEventListener("load", updateScrollProgress);

  gsap.to(".header_border", {
    autoAlpha: 1,
    scrollTrigger: {
      scrub: 1,
      trigger: "body",
      start: 10,
      end: 100,
    },
  });

  let sideMenu = document.querySelector(".side_menu");;
  if(sideMenu) {
    document.querySelector(".side_menu").addEventListener('click', function() {
      sideMenu.classList.toggle('is_open');
    });
  }

}

// --------------------------------------------------
// 📜 Scroll Menu
// --------------------------------------------------

if (document.body.classList.contains("t_article")) {

  let anchors = gsap.utils.toArray("nav.anchors a.anchor");
  let activeAnchors = gsap.utils.toArray(".active_anchor");

  anchors.forEach(function (anchor) {
    let id = anchor.getAttribute("href");
    if (id != "#") {
      let anchorBlock = document.querySelector(id);
      if (anchorBlock) {
        anchor.addEventListener("click", function (e) {
          gsap.to(window, {
            scrollTo: {
              y: anchorBlock,
              offsetY: 100,
            },
            ease: "power2.inOut",
            duration: 2,
          });
          history.pushState(null, null, id);
          e.preventDefault();
        });
      }
    }
  });

  function activeChapter() {
    let activeAnchor = false;
    anchors.forEach(function (anchor) {
      let id = anchor.getAttribute("href");
      if (id != "#") {
        let anchorBlock = document.querySelector(id);
        if (anchorBlock) {
          if (
            anchorBlock.getBoundingClientRect().top <
            window.innerHeight / 2
          ) {
            activeAnchor = anchor;
          }
        }
      }
    });
    if (activeAnchor) {
      activeAnchors.forEach(function (anchor) {
        if (
          anchor.getAttribute("data-id") == activeAnchor.getAttribute("href")
        ) {
          anchor.classList.add("is_active");
        } else {
          anchor.classList.remove("is_active");
        }
      });
    } else {
      activeAnchors.forEach(function (anchor) {
        if (anchor.getAttribute("data-id") == "#") {
          anchor.classList.add("is_active");
        } else {
          anchor.classList.remove("is_active");
        }
      });
    }
  }

  activeChapter();
  window.addEventListener("scroll", activeChapter);
  window.addEventListener("load", activeChapter);
}
